import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { securityBwicHistoryActions } from '../../actions/entities/security-bwic-history.actions';
import { SecurityBwicStatisticsSummary } from '../../types/security/SecurityBwicStatisticsSummary';
import { bwicService } from '../../services';

function* watchRequestHistory(action: ActionType<typeof securityBwicHistoryActions.request>) {
    try {
        const statistics: SecurityBwicStatisticsSummary = yield call(
            bwicService.getSecurityBwicStatistics, action.payload.securityId);

        yield put(securityBwicHistoryActions.requestResult(action.payload.securityId, statistics));
    } catch (e) {
        yield put(securityBwicHistoryActions.requestFailure(action.payload.securityId));
    }
}

export function* watchSecurityBwicHistory() {
    yield takeEvery(getType(securityBwicHistoryActions.request), watchRequestHistory);
}
